var Helperfn = function() {

  function init() {
    //Helper Function to verify multiple Classes
    $.fn.extend({
      hasClasses: function(selector) {
        var classNamesRegex = new RegExp("( " + selector.replace(/ +/g, "").replace(/,/g, " | ") + " )"),
          rclass = /[\n\t\r]/g,
          i = 0,
          l = this.length;
        for (; i < l; i++) {
          if (this[i].nodeType === 1 && classNamesRegex.test((" " + this[i].className + " ").replace(rclass, " "))) {
            return true;
          }
        }
        return false;
      }
    });
  }

  return {
    init: init
  };

}();

export { Helperfn };